import tinycolor from 'tinycolor2';

const primary = '#006469';
const secondary = '#F8B7AD';
const error = '#EB5861';
const warning = '#FEB84F';
const success = '#009D9A';
const info = '#10b0c3';
// const primary = "#009688";
// const secondary = "#FA9284";
// const error = "#B00020";
// const warning = "#FFC260";
// const success = "#3CD4A0";
// const info = "#9013FE";

const lightenRate = 7.5;
const darkenRate = 15;

export default {
  palette: {
    primary: {
      main: primary,
      light: tinycolor(primary).lighten(lightenRate).toHexString(),
      dark: tinycolor(primary).darken(darkenRate).toHexString(),
    },
    secondary: {
      main: secondary,
      light: tinycolor(secondary).lighten(lightenRate).toHexString(),
      dark: tinycolor(secondary).darken(darkenRate).toHexString(),
      contrastText: '#FFFFFF',
    },
    error: {
      main: error,
      light: tinycolor(error).lighten(lightenRate).toHexString(),
      dark: tinycolor(error).darken(darkenRate).toHexString(),
    },
    warning: {
      main: warning,
      light: tinycolor(warning).lighten(lightenRate).toHexString(),
      dark: tinycolor(warning).darken(darkenRate).toHexString(),
    },
    success: {
      main: success,
      light: tinycolor(success).lighten(lightenRate).toHexString(),
      dark: tinycolor(success).darken(darkenRate).toHexString(),
    },
    info: {
      main: info,
      light: tinycolor(info).lighten(lightenRate).toHexString(),
      dark: tinycolor(info).darken(darkenRate).toHexString(),
    },
    text: {
      primary: '#4A4A4A',
      secondary: '#6E6E6E',
      hint: '#B9B9B9',
    },
    background: {
      default: '#F6F7FF',
      light: '#F3F5FF',
    },
  },
  overrides: {
    MuiOutlinedInput: {
      notchedOutline: {
        border: '1px solid rgba(0, 0, 0, 0.23) !important',
      },
    },
    MuiInputLabel: {
      marginDense: {
        transform: 'translate(14px, 17px) scale(0.7) !important',
      },
      shrink: {
        transform: 'translate(14px, 0px) scale(0.75) !important',
      },
    },
    MuiBackdrop: {
      root: {
        backgroundColor: '#4A4A4A1A',
      },
    },
    MuiMenu: {
      paper: {
        boxShadow: '0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
      },
    },
    MuiSelect: {
      icon: {
        color: '#B9B9B9',
      },
    },
    MuiListItem: {
      button: {
        '&:hover, &:focus': {
          backgroundColor: '#F3F5FF',
        },
      },
    },
    MuiTouchRipple: {
      child: {
        backgroundColor: 'white',
      },
    },
    MuiTableRow: {
      root: {
        borderTop: '1px solid rgba(224, 224, 224, .5)',
        height: 'auto',
        verticalAlign: 'middle',
      },
    },
    MuiTableCell: {
      root: {
        borderBottom: '1px solid rgba(224, 224, 224, .5)',
        paddingLeft: '5px',
        paddingRight: '5px',
      },
      head: {
        fontSize: '1rem',
        color: '#212529',
        fontWeight: 'bold',
        zIndex: 0,
      },
      body: {
        fontSize: '0.95rem',
        zIndex: 0,
      },
    },
    MUIDataTableHeadCell: {
      root: {
        // '&:nth-child(2)': {
        //   width: 120
        // }
      },
      fixedHeaderCommon: {
        zIndex: 0,
      },
    },
    MUIDataTable: {
      responsiveScrollFullHeight: {
        overflow: 'auto',
      },
    },
  },
};
